import React, { useEffect } from "react";
import "./App.css";
import HomePage from "./components/HomePage/HomePage";
import Notice from "./components/notice/notice";
import ExMem from "./components/member/personlist";
import Login from "./containers/Login/Login";
import axios from "axios";
import { getCookie } from "./components/Utils/Cookie";
import { Subscribe } from "unstated";
import RECSPContainer from "./Store/recspContainer";
import Adminpanel from "./containers/AdminPanel/AdminPanel";
import Winner from "./components/Winner/Winner";
import Profile from "./components/Profile/Profile";
import { Route, Switch } from "wouter";
import Post from "./Quiz/Panel/Post/Post";
import Landing from "./Quiz/Landing/Landing";
import Quiz from "./Quiz/Quiz";
import Practice from "./Quiz/Pratice";
import Invalid from "./Quiz/Invalid/Invalid";
import Thank from "./Quiz/Thank/Thank";
import Query from "./Quiz/Panel/Query/Query";
import Update from "./Quiz/Panel/Update/Update";
import Result from "./Quiz/Result/Result";
import Response from "./Quiz/Response/Response";
import Resp from "./Quiz/Response/Resp/Resp";
import QuestionBank from "./components/Questions/QuestionBank";
import ExamResult from "./components/Result/Result";
import Notes from "./components/Notes/Notes";
import Assignments from "./components/Assignments/Assignments";
import Register from "./containers/Register/Register";
import OtpVerify from "./containers/Register/OtpVerify";
// import MobileVerify from "./containers/Register/MobileVerify";
import UserDetails from "./containers/Register/UserDetails";

export default function App(props) {

  useEffect(() => {
    checkLoginState();
  }, []);

  function getLoggedIn() {
    return props.mainContainer.state.isLoggedIn;
  }

  function checkLoginState() {
    if (getCookie("_RSPRFTOKEN") !== "") {
      let rft = getCookie("_RSPRFTOKEN");

      let postData = {
        refToken: rft,
        key: props.mainContainer.state.publicKey,
      };

      axios.post(
        `${props.mainContainer.state.apiUrl}fromRefToken.php`,
        postData,
        { withCredentials: true, headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((response) => {
        if (response.data.status === 201) props.mainContainer.doLogin(response.data.data);
      })
      .catch(() => {});
    }
  }

  return (
    <div className="App">
      <Switch>

        {/* HOME */}
        <Route exact path="/">
          <HomePage store={props.mainContainer} isLoggedIn={getLoggedIn}/>
        </Route>

        {/* REGISTER FLOW */}
        <Route path="/register" component={Register}/>
        <Route path="/otp" component={OtpVerify}/>
        {/* <Route path="/mobile" component={MobileVerify}/> */}
        <Route path="/details" component={UserDetails}/>

        {/* LOGIN */}
        <Route path="/login" component={Login}/>

        {/* QUIZ */}
        <Route path="/error" component={Invalid}/>
        <Route path="/thank" component={Thank}/>
        <Route path="/practice" component={Practice}/>

        <Route path="/quiz/complain" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Query check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/quiz/response" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Response check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/quiz/resp/:id" exact component={Resp}/>

        <Route path="/quiz/panel/question" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Post check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/quiz/panel/complain" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Update check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/quiz/play" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Quiz check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/quiz/rank" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Result check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/quiz" exact component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Landing check={rec}/>)}
          </Subscribe>
        )}/>

        {/* PAGES */}
        <Route path="/questions" component={QuestionBank}/>
        <Route path="/notes" component={Notes}/>
        <Route path="/assignments" component={Assignments}/>

        <Route path="/notice" component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Notice check={rec}/>)}
          </Subscribe>
        )}/>

        <Route path="/winner" component={Winner}/>
        <Route path="/ex-members" component={ExMem}/>

        {/* PROFILE */}
        <Route path="/profile" component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Profile check={rec}/>) }
          </Subscribe>
        )}/>

        {/* ADMIN */}
        <Route path="/adminpanel" component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<Adminpanel check={rec}/>)}
          </Subscribe>
        )}/>

        {/* EXAM RESULT */}
        <Route path="/result" component={() =>(
          <Subscribe to={[RECSPContainer]}>
            {(rec)=>(<ExamResult check={rec}/>)}
          </Subscribe>
        )}/>

      </Switch>
    </div>
  );
}
